import { Component, Input, OnInit } from '@angular/core';
import { CallHistoryService } from '../../call-history.service';
import { CallHistorySearchParams } from '../../call-history-params.interface';

@Component({
  selector: 'cc-direction-filter',
  templateUrl: './direction-filter.component.html',
  styleUrls: ['./direction-filter.component.scss']
})
export class DirectionFilterComponent implements OnInit {
  @Input() filters: CallHistorySearchParams;
  constructor(private callHistoryService: CallHistoryService) {}

  ngOnInit() {}

  addFilter(type, value) {
    this.callHistoryService.addFilter(type, value, this.callHistoryService.getPagerIndexReset(this.filters.pager));
  }
}
